import { Col } from 'react-bootstrap';
import { SectionHeadingMed, HeadingDesc } from '../../../Components/Headings';
import { SimpleButton } from '../../../Components/button';
import CallToAction from '../../../Components/callToAction/CallToAction';
import img1 from '../../../assets/images/png/approveddoc.png';
import './consultDoctor.css';

function ConsultDoctor() {
  return (
    <CallToAction
      leftContent={<LeftContent />}
      rightContent={<RightConten />}
    />
  );
}

function RightConten() {
  return (
    <Col md={5} className="order-lg-2 order-1">
      <div>
        <img src={img1} alt="bloodpressure" />
      </div>
    </Col>
  );
}

function LeftContent() {
  return (
    <Col md={7} className="order-lg-1 order-2">
      <div>
        <SectionHeadingMed text="Lorem ipsum dolor sit amet," />
        <HeadingDesc text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec sollicitudin mattis erat, vel volutpat quam blandit vitae. " />
        <HeadingDesc text="Vivamus quis mauris at velit suscipit eleifend. Nunc ac imperdiet tellus. Aliquam pellentesque ligula dolor, sed rutrum" />
        <SimpleButton text="SCAN YOUR VITALS NOW" bgColor="#EF6286" />
      </div>
    </Col>
  );
}

export default ConsultDoctor;
